import { convertFullWidthToHalfWidthNumber, formatDecimal } from "@lhd/utility";
import { Form, FormItemProps, InputNumber, InputNumberProps } from "antd";
import { debounce, isNil } from "lodash";
import { useState } from "react";
import { Styles } from "./styled";

type IProps = FormItemProps & {
  inputProps: InputNumberProps;
  isFormat?: boolean;
  numberOfDecimalPlace?: number;
  maxChar?: number;
  minChar?: number;
};
const InputNumberFormField = ({
  inputProps,
  isFormat = false,
  numberOfDecimalPlace,
  maxChar,
  minChar,
  ...itemProps
}: IProps) => {
  const form = Form.useFormInstance();
  const [isComposition, setIsComposition] = useState(false);

  const handleSetComposition = debounce((isComposition) => {
    setIsComposition(isComposition);
  }, 10);

  const handleGetValueFromEvent = (valueRaw: any) => {
    if (itemProps.name) {
      const value = isNil(valueRaw)
        ? ""
        : convertFullWidthToHalfWidthNumber(String(valueRaw));

      form.setFieldValue(itemProps.name, value);
      inputProps.onChange?.(value);
    }
  };
  return (
    <Styles>
      <Form.Item
        {...itemProps}
        rules={[
          ...(itemProps.rules || []),
          {
            validator: (_: any, value: string) => {
              if (isNil(value)) return Promise.resolve();
              const valueClean = Number(String(value).replaceAll(",", ""));
              if (!isNil(minChar) && !isNil(maxChar)) {
                if (valueClean > maxChar || valueClean < minChar)
                  return Promise.reject(
                    `その値は${minChar}以上${maxChar}以下でなければなりません。`,
                  );
              } else if (!isNil(minChar)) {
                if (valueClean < minChar)
                  return Promise.reject(
                    `その値は${minChar}以上でなければなりません。`,
                  );
              } else if (!isNil(maxChar)) {
                if (valueClean > maxChar)
                  return Promise.reject(
                    `その値は${maxChar}以下でなければなりません。`,
                  );
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <InputNumber
          onCompositionStart={() => handleSetComposition(true)}
          formatter={(valueRaw, info) => {
            const value =
              (valueRaw as string) || (info.userTyping ? info.input : "") || "";

            const valueFormat = convertFullWidthToHalfWidthNumber(value);

            if (info.userTyping) {
              return String(value ?? "");
            }
            if (isNil(valueFormat)) return "";

            return formatDecimal(
              String(valueFormat),
              isFormat,
              numberOfDecimalPlace,
            );
          }}
          onCompositionEnd={(e) => {
            handleGetValueFromEvent(e.currentTarget.value);
            handleSetComposition(false);
          }}
          {...inputProps}
          onInput={(text) => {
            if (
              text === "" &&
              itemProps.name &&
              form.getFieldValue(itemProps.name) === "NaN"
            ) {
              handleGetValueFromEvent("");
            }
            inputProps.onInput?.(text);
          }}
          onChange={(value) => {
            !isComposition && handleGetValueFromEvent(value as string);
          }}
        />
      </Form.Item>
    </Styles>
  );
};

export default InputNumberFormField;
